<template>
  <div id="filterPanel">
    <div class="filterLine">
        <p><span v-for="item in roleType" 
            class="typeSelector" :class="typeSelectorClass(item)" 
            :key="item.name" 
            @click="typeFilterToggle(item)">
            <span :style="iconThumbtackVisibility(item)">
              <font-awesome-icon icon="thumbtack" size="sm"></font-awesome-icon>
            </span>
            {{item.name}} </span>
        </p>
        <p><span v-for="item in gameType" 
            class="typeSelector" :class="typeSelectorClass(item)" 
            :key="item.name" 
            @click="typeFilterToggle(item)">
            <span :style="iconThumbtackVisibility(item)">
              <font-awesome-icon icon="thumbtack" size="sm"></font-awesome-icon>
            </span>
            {{item.name}} </span>
        </p>
        <input v-model="searchText" placeholder="...搜索英雄/地图名..." />
    </div>
    <div class="libsPanel">
      <div v-for="(group,index) in libsGroups" class="libsGroup" :key="index">
        <div class="libsGroupTitle" @click="groupFoldingToggle(group)">
          <p><font-awesome-icon icon="caret-square-down" v-if="libsGroupFoldFlagObject[group.libType]"></font-awesome-icon>
          <font-awesome-icon :icon="['far','caret-square-right']" v-else></font-awesome-icon>
          {{group.name}}</p>
        </div>
        <!--transition-group name="libsMovement" tag="div" class="libs"-->
        <div class="libsGroupList" :class="libGroupListClass(group)">
          <div v-for="item in group.list" v-if="item.on"
          class="libBtn" :class="libBtnClass(item)" :style="libBtnStyle(item)"
          :key="item.pID.toString()" @click="libBtnClick(item)">
            <p class="btnText">{{item.name}}</p>
          </div>
        </div>
        <div class="foldingArrowUpDown">
          <font-awesome-icon icon="angle-double-down" v-if="libsGroupFoldFlagObject[group.libType]"></font-awesome-icon>
          <font-awesome-icon icon="angle-double-up" v-else></font-awesome-icon>
        </div>
        <!--/transition-group-->
      </div>
    </div>
  </div>
</template>

<script>
import papa from 'papaparse';
import {gameTypeList,
  roleTypeList,
  libTypeNameList} from './data.js'

export default {
  data () {
    return {
      searchText: "",
      roleType: roleTypeList,
      gameType: gameTypeList,
      libTypeNames: libTypeNameList,
      libsGroupFoldFlagObject: {"hero":true,"map":true,"announcer":true,"music":true},
      libs:[//this array is sample data, will be replaced by PapaParser when created()
        {pID:[100],libType:"hero",name:"阿巴瑟",role:"specialist",game:"starcraft",skin:false,on:true,blue:true,red:false},
        {pID:[110],libType:"hero",name:"阿拉纳克",role:"assassin",game:"starcraft",skin:false,on:true,red:true,blue:false}
      ],
      selectedTwins:{
        libType: "hero",
          twins: [null,null]
      },
    }
  },
  props:['currentSide'],
  computed:{
    currentSideColor(){return this.currentSide ? "red":"blue"},
    libsGroups: function () {
			var result = this.libs.reduce((base, add)=> {
        var createNewGroupFlag = true;
        for(let i=base.length-1;i>=0;i--){ //空数组时第一个 i 不满足条件，跳过循环节
          if (base[i].libType==add.libType) {
            base[i].list.push(add);
            createNewGroupFlag = false;
            break;
          };
        }
        if (createNewGroupFlag) {
          var newGroup = Object.create(null);
          newGroup.name = this.libTypeNames[add.libType];//libTypeNames["hero"]
          newGroup.on = add.blue||add.red; //on 定义为是否能通过筛选器
          newGroup.active = add.blue||add.red; //active 样式高亮
          newGroup.libType = add.libType;
          newGroup.list = [add];
          base.push(newGroup);
        }
        return base;
      }, []);
      return result;
    }
  },
  watch:{
    searchText:function () {
      this.applyEveryFilter();
    }
  },
  methods:{
    typeSelectorClass(item){
      var    result     = {};
      result["active"]  = item.active;
      return result;
    },
    iconThumbtackVisibility(item){
      var result = {};
      if (item.active){ result["opacity"] = 1
        } else { result["opacity"] = 0.3 }
      return result;
    },
    libGroupListClass(group){
      var result  = {};
      result['fold'] = this.libsGroupFoldFlagObject[group.libType];
      return result;
    },
    groupFoldingToggle(group){
      this.libsGroupFoldFlagObject[group.libType] = !this.libsGroupFoldFlagObject[group.libType];
    },
    libBtnClass(item){
      var    result     = {};
      result["skin"]    = item.skin;
      result[item.game] = item.game;
      result["blue"]  = item.blue;
      result["red"]  = item.red;
      return result;
    },
    libBtnStyle(item){
      var result = {};
      var order = item.blue? -2 : (item.red? -1: 0);
      if (this.libsGroupFoldFlagObject[item.libType]){
        result["order"] = order;
      }
      return result;
    },
    applyEveryFilter(){
      var doRoleFilter = this.roleType.reduce((base,add)=>{return base||add.active},false);
      var doGameFilter = this.gameType.reduce((base,add)=>{return base||add.active},false);
      //如果有 Type 筛选，把 libs 所有折叠打开，反之重新折叠
      if (doRoleFilter||doGameFilter||this.searchText.length>0){
        for (var key in this.libsGroupFoldFlagObject) {
          this.libsGroupFoldFlagObject[key]=false;
        }
      } else {
        for (var key in this.libsGroupFoldFlagObject) {
          this.libsGroupFoldFlagObject[key]=true;
        }
      };
      //过滤，标记 "on" 属性为 true/false
      this.libs.forEach(libItem=>{
        libItem.on = true;
        if(this.searchText.length>0){
          if (libItem.name.indexOf(this.searchText)===-1
            &&libItem.pinyin.indexOf(this.searchText.toLowerCase())===-1
            &&libItem.py.indexOf(this.searchText.toLowerCase())===-1){
              libItem.on=false;
          }
        }
        if (doRoleFilter&&libItem.on&&libItem.role!=null) {
          libItem.on = this.roleType.reduce((r,a)=>{
            if (a.active) {
              return r||libItem.role.includes(a.tagValue);
            } else {return r}
          },false);
        };
        if (doGameFilter&&libItem.on&&libItem.game!=null) {
          libItem.on = this.gameType.reduce((r,a)=>{
            if (a.active) {
              return r||libItem.game.includes(a.tagValue);
            } else {return r}
          },false);
        };
      });
    },
    typeFilterToggle(item){
      item.active = !item.active;
      this.applyEveryFilter();
    },
    libBtnClick(item){
      //check if libType is changed:
      if (item.libType!=this.selectedTwins.libType) {
        ga('send','event',item.libType,'select',item.name,item.libID)
        this.selectedTwins.twins[0].blue=false;
        this.selectedTwins.twins[1].red=false;
        this.selectedTwins.libType=item.libType;
        item.red=true;
        item.blue=true;
        this.$set(this.selectedTwins.twins,0,item);
        this.$set(this.selectedTwins.twins,1,item);
      } else {
        if (item[this.currentSideColor]==false) {
          this.selectedTwins.twins[this.currentSide][this.currentSideColor]=false;
          item[this.currentSideColor]=true;
          this.$set(this.selectedTwins.twins,this.currentSide,item);
        };
      };
      this.$emit('listChanged',this.selectedTwins);
    }
  },
  created: function () {
    var me = this;
    var l,r,heroNumberMax = 0;
    papa.parse("/static/libs.csv",{
      download: true,
      header: true,
      dynamicTyping: true,
      encoding: "UTF-8",
      complete: function(result){
        var tmp = {};
        result.data.sort((a,b)=>{return a.libID-b.libID});
        let liblist = result.data.reduce((base,add)=>{
          add.on = true;
          add.blue = false;
          add.red = false;
          add.pID = add.pID.toString().split(',');
          tmp[add.libType] = true;
          if (base.length) {
            let pre = base[base.length-1];
            if (add.libID == pre.libID){
              pre.pID = pre.pID.concat(add.pID);
            } else {base.push(add)};
          } else {base.push(add);}
          return base;
        },[]);

        me.libsGroupFoldFlagObject = tmp;
        me.libs = liblist;
        /* random 2 heroes for gallery on loading*/
        var lastHeroLibPosition = 0;
        for (let i = me.libs.length -1; i >= 0; i--) {
          if (me.libs[i].libType != "hero"){
            lastHeroLibPosition = i-1;
          }
        }
        lastHeroLibPosition = lastHeroLibPosition > 0 ? lastHeroLibPosition : 1;
        var randomBlue = Math.floor(Math.random()*lastHeroLibPosition);
        var randomRed = Math.floor(Math.random()*lastHeroLibPosition);
        me.libs[randomBlue].blue  = true;
        me.libs[randomRed].red    = true;
        me.selectedTwins.twins[0] = me.libs[randomBlue];
        me.selectedTwins.twins[1] = me.libs[randomRed];
        me.$emit("listChanged",me.selectedTwins)
      }
    });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
#filterPanel{
  padding: 12px;
  margin-top: 20px;
  margin-bottom: 40px;
  position: relative;
  background: rgba(255, 255, 255, 0.25);
  user-select: none;
}

.filterLine{
  display: flex;
  justify-content: space-around;
  padding: 0;
  cursor: pointer;
  .typeSelector{
    border-left: 2px solid rgba(100, 100, 100, 0.7);
    padding: 0 0 0 4px;
    &:first-child{
      border-left:none;
    }
    &:hover{
      color:#4ca0ff;
    }
    &.active{
      font-weight: bold;
    }
  }
}

.libsGroup{
  display: flex;
  margin-top: 4px;
  padding: 2px 0px;
  &:nth-child(n+1){border-top:1px solid #fff;}
  .libsGroupTitle{
    white-space: nowrap;
    min-width: 64px;
    cursor: pointer;
  }
  .libsGroupList{
  display: flex;
  flex-wrap: wrap;
  &.fold {
    max-height: 100px;
    overflow: hidden;
  }
}
}

.libBtn{
  display:flex;
  align-items: flex-end;
  height: 24px;
  padding: 1px 2px;
  font-weight: bold;
  user-select: none;
  cursor: pointer;
  p.btnText{
    transition:0.5s;
    color:#e5e5e5;
    padding: 0 0 0 2px;
    border-left: 4px solid rgba(0, 0, 0, 0);
    text-shadow: 1px 0px 6px rgba(0, 0, 0, 0.8),
      0px 1px 6px rgba(0, 0, 0, 0.8),
      -1px 0px 6px rgba(0, 0, 0, 0.8),
      0px -1px 6px rgba(0, 0, 0, 0.8);
    }
  &.skin p.btnText{
      font-size: 12px;
      color: #e0e0e0;
      text-shadow: 1px 0px 6px rgba(0, 0, 0, 0.8),
        0px 1px 6px rgba(0, 0, 0, 0.8),
        -1px 0px 6px rgba(0, 0, 0, 0.8),
        0px -1px 6px rgba(0, 0, 0, 0.8);
  }
}
.libBtn:hover{
  p.btnText{
    color:#fff;
    text-shadow: 4px 0px 12px rgba(0,0,0, 0.9),
    0px 4px 12px rgba(0,0,0, 0.9),
    -4px 0px 12px rgba(0,0,0, 0.9),
    0px -4px 12px rgba(0,0,0, 0.9);
  }
  &.starcraft p.btnText{border-left: 4px solid #4ca0ff}
  &.warcraft p.btnText{border-left: 4px solid #ffe0a4}
  &.overwatch p.btnText{border-left: 4px solid #b2b2b2}
  &.diablo p.btnText{border-left: 4px solid #ff8da3}
  &.retro p.btnText{border-left: 4px solid #05aefd}
  &.nexus p.btnText{border-left: 4px solid #ff00ff}
}
.libBtn.red{
  p.btnText{
    color:#fcfcfc;
    /*font-size: 18px;*/
    text-shadow: 2px 0px 5px rgba(255, 50, 0, 0.8),
    0px 2px 5px rgba(255, 50, 0, 0.8),
    -2px 0px 5px rgba(255, 50, 0, 0.8),
    0px -2px 5px rgba(255, 50, 0, 0.8);
  }
  &.starcraft p.btnText{border-left: 4px solid #4ca0ff}
  &.warcraft p.btnText{border-left: 4px solid #ffe0a4}
  &.overwatch p.btnText{border-left: 4px solid #b2b2b2}
  &.diablo p.btnText{border-left: 4px solid #ff8da3}
  &.retro p.btnText{border-left: 4px solid #05aefd}
  &.nexus p.btnText{border-left: 4px solid #ff00ff}
}
.libBtn.blue{
  p.btnText{
    /*font-size: 18px;*/
    color:#fcfcfc;
    text-shadow: 2px 0px 5px rgba(0, 50, 255, 0.8),
    0px 2px 5px rgba(0, 50, 255, 0.8),
    -2px 0px 5px rgba(0, 50, 255, 0.8),
    0px -2px 5px rgba(0, 50, 255, 0.8);
  }
  &.starcraft p.btnText{border-left: 4px solid #4ca0ff}
  &.warcraft p.btnText{border-left: 4px solid #ffe0a4}
  &.overwatch p.btnText{border-left: 4px solid #b2b2b2}
  &.diablo p.btnText{border-left: 4px solid #ff8da3}
  &.retro p.btnText{border-left: 4px solid #05aefd}
  &.nexus p.btnText{border-left: 4px solid #ff00ff}
}
.libBtn.blue.red{
  p.btnText{
    color:#fcfcfc;
    text-shadow: 2px 0px 5px rgba(255, 255, 255, 0.4),
    0px 2px 5px rgba(255, 255, 255, 0.4),
    -2px 0px 5px rgba(255, 255, 255, 0.4),
    0px -2px 5px rgba(255, 255, 255, 0.4);
  }
  &.starcraft p.btnText{border-left: 4px solid #4ca0ff}
  &.warcraft p.btnText{border-left: 4px solid #ffe0a4}
  &.overwatch p.btnText{border-left: 4px solid #b2b2b2}
  &.diablo p.btnText{border-left: 4px solid #ff8da3}
  &.retro p.btnText{border-left: 4px solid #05aefd}
  &.nexus p.btnText{border-left: 4px solid #ff00ff}
}

.icon {
  background-image: url(../assets/tagType.png);
  width: 50px;
  height: 50px;
  display: inline-block;
  background-position-y: -3px;
  margin: 0px;padding:0px;
  &:hover {background-position-y: -53px}
  &.active {background-position-y: -103px}
}

.libsMovement-move{transition: all 0.5s}
.libsMovement-enter-active{transition: all 0.5s}
.libsMovement-leave-active {
  transition: all 0.5s;
}
.libsMovement-enter, .libsMovement-leave-to{
  opacity:0;
  transform: translateY(100px) scale(0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/filterPanel.vue